'use client';

import { type ReactElement } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import type TFunctionResult from 'i18next';

interface ILinkText {
  pathname: string;
  query?: { [key: string]: string } | 'undefined';
  locale?: string;
  classNames?: string;
  onClick?: () => void;
  children: ReactElement | number | string | typeof TFunctionResult;
  dataUITestClass?: string;
}

export const LinkText = ({ pathname, query, locale, classNames, onClick, children, dataUITestClass }: ILinkText) => {
  const router = useRouter();

  return (
    <Link
      href={{
        pathname: router?.query?.countryCode ? `/${router?.query?.countryCode}${pathname}` : pathname,
        query: query !== 'undefined' ? query : '',
      }}
      locale={locale ? locale : router?.locale ? router?.locale : router?.defaultLocale}
      className={classNames}
      data-testid={dataUITestClass}
      onClick={onClick}
    >
      <>{children}</>
    </Link>
  );
};

LinkText.displayName = 'LinkText';
